<h1 class="text-white text-lg font-semibold mb-4">Gestión de Rutas</h1>
<div class="mb-4 flex justify-between items-center">
    <button matButton (click)="onCreateRoute()" *ngIf="canCreateRoute$ | async">Crear Nueva Ruta</button>
    <mat-form-field class="ml-4 border-0">
        <input matInput (input)="applyFilter($event)" placeholder="Buscar...">
    </mat-form-field>
</div>
<div *ngIf="dataSource.data.length === 0" class="text-center py-8 text-gray-500">
    <p>No hay rutas registradas.</p>
</div>
<div class="mat-elevation-z2">
    <table mat-table [dataSource]="dataSource" matSort class="w-full">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </th>
            <td mat-cell *matCellDef="let route"> {{ route.name }} </td>
        </ng-container>
        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Activo </th>
            <td mat-cell *matCellDef="let route"> {{ route.status ? 'Sí' : 'No' }} </td>
        </ng-container>
        <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Creado </th>
            <td mat-cell *matCellDef="let route">{{ route.createdAt | date:'dd-MM-yyyy, hh:mm:ss a' }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Acciones </th>
            <td mat-cell *matCellDef="let route">
                <button mat-icon-button color="accent" aria-label="Editar ruta" (click)="onEditRoute(route)" *ngIf="canEditRoute$ | async">
                    <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" aria-label="Eliminar ruta" (click)="onDeleteRoute(route.id)" *ngIf="canDeleteRoute$ | async">
                    <mat-icon>delete</mat-icon>
                </button>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons aria-label="Seleccionar página de rutas"></mat-paginator>
</div>
